import { render } from "./StylesInspectorView.vue?vue&type=template&id=04c9d160"
import script from "./StylesInspectorView.vue?vue&type=script&lang=js"
export * from "./StylesInspectorView.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__